import { NgModule } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";

@NgModule()
export class IconsModule {
    /**
     * Constructor
     */
    constructor(private _domSanitizer: DomSanitizer, private _matIconRegistry: MatIconRegistry) {
        // Register icon sets
        this._matIconRegistry.addSvgIconSet(
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-twotone.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "mat_outline",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-outline.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "mat_solid",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-solid.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "feather",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/feather.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "heroicons_outline",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/heroicons-outline.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "heroicons_solid",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/heroicons-solid.svg")
        );


        // Material Symbols
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_outlined_100",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-outlined-100.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_outlined_200",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-outlined-200.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_outlined_300",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-outlined-300.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_outlined_400",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-outlined-400.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_outlined_500",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-outlined-500.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_outlined_600",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-outlined-600.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_outlined_700",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-outlined-700.svg")
        );

        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_rounded_100",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-rounded-100.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_rounded_200",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-rounded-200.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_rounded_300",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-rounded-300.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_rounded_400",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-rounded-400.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_rounded_500",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-rounded-500.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_rounded_600",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-rounded-600.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_rounded_700",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-rounded-700.svg")
        );

        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_sharp_100",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-sharp-100.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_sharp_200",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-sharp-200.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_sharp_300",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-sharp-300.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_sharp_400",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-sharp-400.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_sharp_500",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-sharp-500.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_sharp_600",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-sharp-600.svg")
        );
        this._matIconRegistry.addSvgIconSetInNamespace(
            "material_symbols_sharp_700",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/material-symbols-sharp-700.svg")
        );

        // Custom

        this._matIconRegistry.addSvgIcon(
            "ico_window_open",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/window-open-variant.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_window_closed",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/window-closed-variant.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_clean",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/bucket-cleaning-svgrepo-com.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_not_disturbe",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/do-not-disturb-cropped.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_clean_room",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/state-clean.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_clean_room_2",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/state-clean-2.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_dirty",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/state-dirty.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_dirty_2",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/state-dirty-2.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_fan_auto",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/fan-auto.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_fan_one",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/fan-speed-1.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_fan_two",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/fan-speed-2.svg")
        );
        this._matIconRegistry.addSvgIcon(
            "ico_smartroom_fan_three",
            this._domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/fan-speed-3.svg")
        );
    }
}
